import { type GetServerSidePropsContext } from 'next';
import { getEmptyLayout } from '@/layout';
import { getDefaultServerSideProps } from '@/utils';
import { TeacherDashboardPrototypePageView } from '../[id]/teacher-dashboard-prototype/TeacherDashboardPrototypePageView';
export default function StandaloneTeacherDashboardPrototypePage() {
  return <TeacherDashboardPrototypePageView standalone data-sentry-element="TeacherDashboardPrototypePageView" data-sentry-component="StandaloneTeacherDashboardPrototypePage" data-sentry-source-file="index.page.tsx" />;
}
StandaloneTeacherDashboardPrototypePage.getLayout = getEmptyLayout;
export const getServerSideProps = async ({
  locale
}: GetServerSidePropsContext) => {
  return await getDefaultServerSideProps({
    locale,
    namespaces: ['lms']
  });
};